/**
 * @fileoverview POST handler for the "/companies/:company_id/email_self_serve/:app_group_id/sending_domain/:domain_id/tracking_domain" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdEmailSelfServeSendingDomainDomainIdTrackingDomainCacheKeys } from "./constants";
import type { PostTrackingDomainProps, PostTrackingDomainResult } from "./types";

export const postTrackingDomain = reactQueryMutationAdapter(
  companiesCompanyIdEmailSelfServeSendingDomainDomainIdTrackingDomainCacheKeys,
  (props: PostTrackingDomainProps): Promise<PostTrackingDomainResult> => {
    const { companyId, appGroupId, parentDomainId, ...requestBody } = props;

    return fetch(
      `/companies/${companyId}/email_self_serve/${appGroupId}/sending_domain/${parentDomainId}/tracking_domain`,
      "POST",
      requestBody,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
